module.exports = __webpack_public_path__ + "static/media/xu_xue_gong_jue.d4fd02c7.png";